import { cartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(cartLineQuantityStyles, {
    editableQuantityTextField: {
        labelProps: {
            variant: "p",
            weight: 600,
            css: css`
                display: inline-flex;
                align-items: center;
                justify-content: center;
                font-size: ${TYPOGRAPHY.size.smaller};
                margin-bottom: 0.25rem;
                width: 55%;
                @media (max-width: 1199px) and (min-width: 992px) {
                    font-size: ${TYPOGRAPHY.size.smallest} !important;
                }
                @media print {
                    font-size: ${TYPOGRAPHY.size.tiny};
                }
            `,
        },
        cssOverrides: {
            formField: css`
                margin-top: 0px;
                flex-direction: row;
                align-items: center;
                background-color: #e1e7ed;
                color: ${COLORS.lightBlack};
                border-radius: 8px;
                margin-bottom: 3px;
                & > div {
                    margin-top: 0 !important;
                    input[data-test-selector="cartline_qty"] {
                        text-align: center !important;
                        padding-left: 0 !important;
                        padding-right: 2px !important;
                        font-size: 14px !important;
                        border-radius: 0px 8px 8px 0px !important;
                        border: 0 none !important;
                        background-color: #f1f6fb !important;
                        & :focus {
                            padding-left: 0 !important;
                            padding-right: 2px !important;
                        }
                        @media print {
                            padding-bottom: 4px !important;
                        }
                    }
                }
            `,
        },
    },
});
